/** "jonathan@acme.com" -> "j•••••••n@acme.com" */
export const maskEmail = (email: string): string => {
    const [local, domain] = email.split('@');
    if (!domain || local.length === 0) return email;
    if (local.length <= 2) return `${local[0]}•@${domain}`;
    return `${local[0]}${'•'.repeat(Math.min(local.length - 2, 8))}${local[local.length - 1]}@${domain}`;
};

/** "8066545758" -> "+1 (•••) •••-5758" */
export const maskPhone = (digits: string): string => `+1 (•••) •••-${digits.slice(-4)}`;
